export enum AssayType{
	HS_LARGE_FRAGMENT = "HS_LARGE_FRAGMENT",
	HS_NGS_FRAGMENT = "HS_NGS_FRAGMENT",
	SS_NGS_FRAGMENT = "SS_NGS_FRAGMENT",
	NO_ASSAY_TYPE = "NO_ASSAY_TYPE"
 }